import { badgesResponseSchema, type BadgesResponse } from '@teentack/shared';
import { apiFetch } from '@/lib/api-client';

/** Earned and locked, with progress on the locked ones. [Teen Phase 6] */
export async function fetchBadges(): Promise<BadgesResponse> {
  return badgesResponseSchema.parse(await apiFetch<unknown>('/badges'));
}
